
import Vue from "vue";
import filters from "@/filters";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import {
  EnumHelper,
  SchoolEventTargetEnum,
  SchoolEventTypeEnum,
} from "@/constants/enum.constant";

@Component({
  components: {},
  filters,
})
export default class EventItem2 extends Vue {
  @Prop({ default: null })
  private event!: any;

  private types = EnumHelper(SchoolEventTypeEnum);

  private isForCandidate(data: any) {
    return data.target === SchoolEventTargetEnum.CANDIDATE;
  }

  private isForCompany(data: any) {
    return data.target === SchoolEventTargetEnum.COMPANY;
  }
}
